import React, { Component } from 'react';
import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo
}
    from 'devextreme-react/data-grid'; //npm install devextreme@19.1 devextreme-react@19.1
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import { StatusType, DateFormat, TripStatus } from '../../helpers/fixcodes';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { getRequestParams } from '../../helpers/globalfunctions.js';
import NumberFormat from 'react-number-format';
import NumericInput from 'react-numeric-input'; //npm install react-numeric-input --save
import Swal from 'sweetalert2';
import { SelectBox } from 'devextreme-react/select-box';
import moment from 'moment/min/moment-with-locales';//npm install --save moment react-moment

const customStyles = {
    content: {
        width: '60%'
    }
};

const position = { of: '#historydiv' };

let currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));

export class AddPassengerComponent extends Component {
    constructor(props) {        
        super(props);
        this.state = {
            isOpenModal: false,
            isSubmited: false,
            isSaveSubmited: false,
            passengerdatasource: null,
            rideId: 0,
            pageName: '',
            loadPanelVisible: false,
            refreshRideSource: props.refreshDataSource,
            handleRefresh: props.handleRefresh,
            allowSocketConnection: sessionStorage.getItem("session_allowSocketConnection") === "true" ? true : false,
            rowIndex: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            isPaxUpdate: false,
            stopDetails: null,
            stopId: 0,
            scheduleActualPickupTime: [],
            rideDetails: [],
            scheduleDateTime: "",
            actualPickupTime: "",
            routeId: 0,            

            errors: {
                paxFirstName: "",
                paxLastName: "",
                mobileNumber: "",
                email: "",
                noOfPax: "",
                stopId: "",
            }
        }

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.getStopList = this.getStopList.bind(this);
        this.getRidePassengerDetails = this.getRidePassengerDetails.bind(this);        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePaxCountChange = this.handlePaxCountChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.hotelPaxDetailsSubmit = this.hotelPaxDetailsSubmit.bind(this);
        this.handleEditAddPassenger = this.handleEditAddPassenger.bind(this);
        this.handleHotelChange = this.handleHotelChange.bind(this);
        this.getRideOnScheduleActualPickupTime = this.getRideOnScheduleActualPickupTime.bind(this);
        this.getRideDetails = this.getRideDetails.bind(this);
        this.handleCancelPassenger = this.handleCancelPassenger.bind(this);
    }

    closeModal() {
        this.setState({
            isOpenModal: false,
            isSubmited: false,
            isSaveSubmited: false,
            pageName: '',
        });
        if (this.state.handleRefresh != undefined || this.state.handleRefresh != null) {
            this.state.handleRefresh(true);
        }
        if (this.state.refreshRideSource != undefined || this.state.refreshRideSource != null) {
            this.state.refreshRideSource();
        }
    }

    showModal(pageName, rideId) {        
        this.setState({
            isOpenModal: true,
            pageName: pageName,
            rideId: rideId,
            passengerdatasource: this.getRidePassengerDetails(rideId),
            rideDetails: this.getRideDetails(rideId),
            stopId: 0,
            puStopId: 0,
            doStopId: 0,
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            isPaxUpdate: false,
            stopDetails: null,
            stopId: 0,
            scheduleActualPickupTime: [],            
            scheduleDateTime: "",
            actualPickupTime: "",
            routeId: 0,
            errors: {
                paxFirstName: "",
                paxLastName: "",
                mobileNumber: "",
                email: "",
                noOfPax: "",
                stopId: "",
            }
        });
    }

    async getRideDetails(rideId) {
        try {
            var reservationId = 0;
            var request = {};
            request.tripId = rideId;
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('reservation-api/trip-details', requestParams);
            debugger;

            const data = await response.json();
            //console.log(data);
            if (data.tripDetails !== null) {
                
                var scheduleDateTime = moment(data.tripDetails.puDateTime).format('HH:mm')                
                await setTimeout(() => this.getStopList(data.tripDetails.routeId), 500);
                this.setState({
                    rideDetails: data.tripDetails,
                    scheduleDateTime: scheduleDateTime,
                    puDateTime: moment(data.tripDetails.puDateTime).format('MM/DD/YYYY'),
                    routeId: data.routeId,
                });
            }
        } catch (e) {
            console.log(e);
        }
    }

    clearControls() {
        this.setState({
            rideId: this.state.rideId,
            //passengerdatasource: this.getRidePassengerDetails(this.state.rideId),
            paxFirstName: "",
            paxLastName: "",
            mobileNumber: "",
            email: "",
            noOfPax: "",
            isPaxUpdate: false,
            rowIndex: 0,
            //stopDetails: null,
            stopId: 0,
            //scheduleActualPickupTime: [],
            //rideDetails: [],
            //scheduleDateTime: "",
            //actualPickupTime: "",            

            errors: {
                paxFirstName: "",
                paxLastName: "",
                mobileNumber: "",
                email: "",
                noOfPax: "",
                stopId: "",
            }
        });
    }

    async getRidePassengerDetails(rideId) {
        try {
            this.setState({
                loadPanelVisible: true
            });

            var reservationId = 0;            
            var request = {};
            request.Id = reservationId;
            request.RideId = rideId;
            request.PuStopId = 0;
            request.PuDateTime = "";
            const requestParams = getRequestParams('POST', request);

            const response = await fetch('reservation-api/PaxDetails', requestParams);
            const data = await response.json();

            this.setState({
                passengerdatasource: data.ridePassengerDetails,
                loadPanelVisible: false
            });

        } catch (e) {
            console.log(e);
        }
    }

    async getStopList(routeId) {
        var shuttleStopsRequest = new Object();
        shuttleStopsRequest.LocationId = Number(sessionStorage.getItem("session_locationId"));

        try {
            const requestParams = getRequestParams('POST', shuttleStopsRequest);
            const response = await fetch('/route-api/' + routeId + '/stop-list', requestParams);
            const data = await response.json();
            //console.log(data);
            this.setState({
                stopDetails: data.shuttleRouteStops
            });

        } catch (e) {
            this.setState({ loadPanelVisible: false });
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.state.errors[name] = "";
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.paxFirstName = "";
        errors.paxLastName = "";
        errors.mobileNumber = "";
        errors.email = "";
        errors.noOfPax = "";
        errors.stopId = "";

        if (this.state.stopId === 0) {
            formIsValid = false;
            errors.stopId = "Please select hotel.";
        }
        if (this.state.paxFirstName.trim() === '') {
            formIsValid = false;
            errors.paxFirstName = "Please enter pax first name.";
        }
        if (this.state.paxLastName.trim() === '') {
            formIsValid = false;
            errors.paxLastName = "Please enter pax last name.";
        }
        if (this.state.mobileNumber.trim() === "") {
            formIsValid = false;
            errors.mobileNumber = "Please enter mobile.";
        } else if (this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length != 10) {
            formIsValid = false;
            errors.mobileNumber = "Invalid mobile number.";
        }
        if (parseInt(this.state.noOfPax | 0) == 0) {
            formIsValid = false;
            errors.noOfPax = "Please enter no of pax.";
        }
        else if (parseInt(this.state.noOfPax | 0) > 60) {
            formIsValid = false;
            errors.noOfPax = "Please enter no of pax less than 60.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handlePaxCountChange(value) {
        this.setState({ noOfPax: value });
        if (value > 0) {
            this.state.errors["noOfPax"] = ""
        }
    }

    async hotelPaxDetailsSubmit() {
        if (!this.handleValidation()) {
            return;
        }

        var newObject = new Object();
        let paxCount = (parseInt(this.state.noOfPax | 0));
        newObject.rowIndex = this.state.rowIndex;
        newObject.accountId = this.state.passengerdatasource.accountId === undefined ?
            parseInt(sessionStorage.getItem("session_accountId")) : parseInt(this.state.passengerdatasource.accountId);
        newObject.rideId = this.state.rideId;
        newObject.paxCount = paxCount;
        newObject.paxFirstName = this.state.paxFirstName;
        newObject.paxLastName = this.state.paxLastName;
        newObject.mobile = this.state.mobileNumber;
        newObject.email = this.state.email;
        newObject.pax = paxCount;
        newObject.puStopId = this.state.stopId;
        newObject.doStopId = 0;
        newObject.createdBy = parseInt(sessionStorage.getItem("session_userId"));
        newObject.pickupDateTime = this.state.actualPickupTime;
        newObject.isCancelled = false;

        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('reservation-api/addEditPassengerDetails', requestParams);
        const data = await response.json();

        Swal.fire({
            icon: data.isSuccess ? 'success' : 'error',
            title: data.isSuccess ? 'Success' : 'Oops...',
            html: data.resultMessage,
            width: '25%',
            allowOutsideClick: false
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (data.isSuccess) {
                if (result.isConfirmed) {
                    this.getRidePassengerDetails(this.state.rideId);
                    this.clearControls();
                    //debugger;
                    //if (this.state.handleRefresh != undefined || this.state.handleRefresh != null) {
                    //    this.state.handleRefresh(true);
                    //}
                    //if (this.state.refreshRideSource != undefined || this.state.refreshRideSource != null) {
                    //    this.state.refreshRideSource();
                    //}
                }
            }
        });
    }

    handleEditAddPassenger(e, data) {
        e.preventDefault();
        this.setState({
            isPaxUpdate: true,
            isOpenModal: true,
            rowIndex: data.rowIndex,
            paxFirstName: data.firstName,
            paxLastName: data.lastName,
            mobileNumber: data.mobile,
            email: data.email,
            noOfPax: data.pax,
            stopId: data.puStopId,
        });
    }

    async handleCancelPassenger(e, data) {
        e.preventDefault();

        //let confirmationQuestion = "Are You Sure Want To cancel booking?";
        //let isConfirmed = await askConfirmation(
        //    confirmationQuestion,
        //    "Yes",
        //    "No"
        //);
        //if (!isConfirmed) return;
        //setState((prev) => ({
        //    ...prev,
        //    isSubmitted: true,
        //}));

        let isConfirmed = false;
        await Swal.fire({
            title: "<small>Cancel Booking</small>",
            html: "Are you sure want to cancel this booking?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isConfirmed = true;
            }
        })

        if (isConfirmed) {
            var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
            var pickupDate = [];
            pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1)
                : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0"
                    + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear() + " " + this.state.pickupTime);

            var newObject = new Object();
            let paxCount = (parseInt(data.pax | 0));
            newObject.rowIndex = data.rowIndex;
            newObject.accountId = this.state.passengerdatasource.accountId === undefined ?
                parseInt(sessionStorage.getItem("session_accountId")) : parseInt(this.state.passengerdatasource.accountId);
            newObject.rideId = this.state.rideId;
            newObject.paxCount = paxCount;
            newObject.paxFirstName = data.firstName;
            newObject.paxLastName = data.lastName;
            newObject.mobile = data.mobile;
            newObject.email = data.email;
            newObject.pax = paxCount;
            newObject.puStopId = this.state.stopId;
            newObject.doStopId = parseInt(0);
            newObject.createdBy = parseInt(sessionStorage.getItem("session_userId"));
            newObject.pickupDateTime = this.state.actualPickupTime;
            newObject.isCancelled = true;

            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('reservation-api/addEditPassengerDetails', requestParams);
            const resultset = await response.json();

            Swal.fire({
                icon: resultset.isSuccess ? 'success' : 'error',
                title: resultset.isSuccess ? 'Success' : 'Oops...',
                html: resultset.resultMessage,
                width: '25%',
                allowOutsideClick: false
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (resultset.isSuccess) {
                    if (result.isConfirmed) {
                        this.getRidePassengerDetails(this.state.rideId);
                        this.clearControls();
                    }
                }
            });
        }
    }

    handleHotelChange = async (e) => {
        if (e.selectedItem != null) {
            await setTimeout(() => this.getRideOnScheduleActualPickupTime(e.selectedItem.stopId), 1000);

            this.setState({
                stopId: e.selectedItem.stopId,
            });
        }
    }

    getRideOnScheduleActualPickupTime = async (stopId) => {
        try {
            var request = {};
            request.RowIndex = 0;
            request.RouteScheduleId = 0;
            request.RouteStopId = parseInt(stopId);
            request.ScheduleGroupId = 0;
            request.ScheduleTime = "";

            const requestParams = getRequestParams('POST', request);
            const response = await fetch('/shuttle-schedule-api/schedule-actual-pickuptime', requestParams);
            const data = await response.json();

            if (data !== null) {
                if (data?.scheduleActualPickupTime !== null) {                    
                    //console.log(data?.scheduleActualPickupTime);
                    //console.log(this.state.scheduleDateTime);
                    var actualPickupTime = "";
                    var dates = data?.scheduleActualPickupTime.filter((e) => e.scheduleTime >= this.state.scheduleDateTime);
                    if (dates !== null) {
                        if (dates.length > 0) {
                            actualPickupTime = dates[0].actualPickupTime;
                        }
                    }

                    this.setState({
                        scheduleActualPickupTime: data?.scheduleActualPickupTime,
                        actualPickupTime: this.state.puDateTime + " " + actualPickupTime,
                    });
                }
            }
        }
        catch (ex) {
            console.log(ex);
        }
    }

    render() {
        const renderGridCell = (data) => {          
            var dt1 = new Date(currentTime);
            var dt2 = new Date(data.data.pickupDateTime);
            var time_difference = dt2.getTime() - dt1.getTime();
            var result = time_difference / (1000 * 60);            
            return <div>
                &nbsp;<a href="#" className="fas fa-times icon text-info" title="Cancel" onClick={(e) => { this.handleCancelPassenger(e, data.data) }} ></a>
                &nbsp;&nbsp;{result > 30 &&
                    <a href="#" className="fas fa-pen icon text-info" title="Update" onClick={(e) => { this.handleEditAddPassenger(e, data.data) }} ></a>}&nbsp;
            </div>;
        }
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={customStyles}
                    className={"react-modal"}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form>
                        <div className="modal-header">
                            <h6 className="modal-title">{this.state.pageName} - <strong><i>{this.state.rideId}</i></strong></h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row" style={{ overflow: "auto", height: "100%" }}>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label htmlFor="">Select Hotel <span className="text-danger">*</span></label>
                                        <SelectBox
                                            dataSource={this.state.stopDetails}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select hotel"
                                            name="stopId"
                                            value={this.state.stopId}
                                            displayExpr='stopName'
                                            valueExpr='stopId'
                                            onSelectionChanged={async (e) => { await this.handleHotelChange(e) }}
                                            showClearButton={true}
                                            searchEnabled={true}
                                            disabled={this.state.isPaxUpdate}
                                        />
                                        {/*{this.state.errors["stopId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["stopId"]}</span>}*/}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label>Passenger First Name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.paxFirstName} onChange={this.handleInputChange} name="paxFirstName" />
                                        {this.state.errors["paxFirstName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paxFirstName"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label>Passenger Last Name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.paxLastName} onChange={this.handleInputChange} name="paxLastName" />
                                        {this.state.errors["paxLastName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paxLastName"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ overflow: "auto", height: "100%" }}>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label>Mobile Number <span className="text-danger">*</span></label>
                                        <NumberFormat className="form-control form-control-sm" name="mobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={this.state.mobileNumber} onChange={this.handleInputChange} format="(###) ###-####" />
                                        {this.state.errors["mobileNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["mobileNumber"]}</span>}
                                    </div>
                                </div>
                                {/*<div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">*/}
                                {/*    <div className="form-group">*/}
                                {/*        <label>Email</label>*/}
                                {/*        <input type="text" className="form-control form-control-sm" name="email" placeholder="test@domain.com" maxLength="100" title="Email" value={this.state.email} onChange={this.handleInputChange} />*/}
                                {/*        {this.state.errors["email"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["email"]}</span>}*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label>Pax# <span className="text-danger">*</span></label>
                                        <NumericInput className="form-control form-control-sm" name="noOfPax" title="Number of Pax" value={this.state.noOfPax} min={1} max={100} onChange={(value) => { this.handlePaxCountChange(value) }} />
                                        {this.state.errors["noOfPax"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["noOfPax"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label><br /></label><br />
                                        {(this.state.isPaxUpdate === false && this.state.rideDetails.rideTypeId === 2) && (
                                            <button type="button" className="btn btn-success btn-sm" onClick={(e) => { this.hotelPaxDetailsSubmit(e, false, false) }} >
                                                {this.state.isSaveSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                                {!this.state.isSaveSubmited && <span title="Save"><i className="fas fa-save"></i> Save</span>}
                                            </button>)}&nbsp;
                                        {this.state.isPaxUpdate === true && (
                                            <button type="button" className="btn btn-success btn-sm" onClick={(e) => { this.hotelPaxDetailsSubmit(e, false, false) }} >
                                                {this.state.isSaveSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                                {!this.state.isSaveSubmited && <span title="Save"><i className="fas fa-save"></i> Update</span>}
                                            </button>)}&nbsp;
                                        <button type="button" className="btn btn-default btn-sm" onClick={(e) => { this.clearControls(e) }} >
                                            <span title="In-process"><i className="fas fa fa-pen"></i> Clear</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-12">
                                    <DataGrid
                                        id="passengerdetails-grid-lite-container"
                                        dataSource={this.state.passengerdatasource}
                                        columnsAutoWidth={true}
                                        showColumnLines={true}
                                        showRowLines={true}
                                        showBorders={true}
                                        rowAlternationEnabled={true}
                                        allowColumnResizing={true}
                                        columnResizingMode='widget'
                                        width={"auto"}
                                        showBorders={true}>

                                        <Column dataField="id" caption="" allowFiltering={false} width="40px" allowSorting={false} cellRender={renderGridCell} />
                                        <Column dataField="firstName" caption="First Name" allowFiltering={false} allowSorting={false} />
                                        <Column dataField="lastName" caption="Last Name" allowFiltering={false} allowSorting={false} />
                                        <Column dataField="puStopName" caption="Pickup" allowFiltering={false} allowSorting={false} />
                                        <Column dataField="pickupDateTime" caption="Pick-up Time" allowFiltering={false} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                                        <Column dataField="pax" caption="Pax" allowFiltering={true} allowSorting={true} />
                                        {/*<Column dataField="email" caption="Email" width={"250px"} allowFiltering={false} allowSorting={false} />*/}
                                        <Column dataField="mobile" caption="Mobile" allowFiltering={false} allowSorting={false} />

                                        <SortByGroupSummaryInfo summaryItem="count" />
                                        <GroupPanel visible={false} />
                                        <HeaderFilter visible={true} />
                                        <SearchPanel visible={false} highlightCaseSensitive={false} width={600} placeholder="Search..." />
                                        <Grouping autoExpandAll={false} />
                                        <Paging defaultPageSize={10} />
                                        <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={false} visible={false} />
                                        <Export enabled={false} allowExportSelectedData={false} />
                                        <ColumnChooser enabled={false} />
                                        <ColumnFixing enabled={true} />
                                    </DataGrid>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.closeModal}><i className="fas fa-times"></i> Close</button>
                        </div>
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            visible={this.state.loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            closeOnOutsideClick={false}
                        />
                    </form>
                </Modal>
            </div>
        );
    }
}